import { lazy } from 'react';

const modals = {
  'accept-deny-trade': lazy(() => import('./AcceptDenyTrade')),
  'buy-sell-order-prompt': lazy(() => import('./BuySellOrderPrompt')),
  'cancel-confirm': lazy(() => import('./CancelConfirm')),
  'leave-review': lazy(() => import('./LeaveReview')),
  'method-selection': lazy(() => import('./MethodSelection')),
  'prompt-confirm': lazy(() => import('./PromptConfirm')),
  'open-dispute': lazy(() => import('./OpenDispute')),
  'payment-status': lazy(() => import('./PaymentStatus')),
  'report-problem': lazy(() => import('./ReportProblem')),
  'report-issue': lazy(() => import('./ReportIssue')),
  'set-alert': lazy(() => import('./SetAlert')),
  'setup-payout': lazy(() => import('./SetupPayout')),
  'trade-approved-notification': lazy(() => import('./TradeApprovedNotification')),
  'trade-completed-notification': lazy(() => import('./TradeCompletedNotification')),
};

export type ModalName = keyof typeof modals;

export type ModalProps<T extends ModalName> = Parameters<(typeof modals)[T]>[0];

export default modals;
